const Plus = (props: { onClick?: () => void; fill?: string; width?: string; height?: string }) => {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={props.onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.00098 9.99946C1.00098 5.02973 5.02973 1.00098 9.99946 1.00098C14.9692 1.00098 18.9979 5.02973 18.9979 9.99946C18.9979 14.9692 14.9692 18.9979 9.99946 18.9979C5.02973 18.9979 1.00098 14.9692 1.00098 9.99946ZM9.99946 2.33128C5.76444 2.33128 2.33128 5.76444 2.33128 9.99946C2.33128 14.2345 5.76444 17.6676 9.99946 17.6676C14.2345 17.6676 17.6676 14.2345 17.6676 9.99946C17.6676 5.76444 14.2345 2.33128 9.99946 2.33128Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.9995 6.00232C10.3669 6.00232 10.6647 6.30012 10.6647 6.66747V13.3341C10.6647 13.7015 10.3669 13.9993 9.9995 13.9993C9.63215 13.9993 9.33435 13.7015 9.33435 13.3341V6.66747C9.33435 6.30012 9.63215 6.00232 9.9995 6.00232Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.00214 9.9995C6.00214 9.63215 6.29994 9.33435 6.66729 9.33435H13.334C13.7013 9.33435 13.9991 9.63215 13.9991 9.9995C13.9991 10.3669 13.7013 10.6647 13.334 10.6647H6.66729C6.29994 10.6647 6.00214 10.3669 6.00214 9.9995Z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};

export default Plus;
